
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuInitialInitialImage } from "@src/constants/images";
import { meta as ryunokoPageMeta } from "./ryunoko.mdx";
import { meta as noodleStandTokyoPageMeta } from "./noodle_stand_tokyo.mdx";
import { meta as minoringoPageMeta } from "./minoringo.mdx";
import { meta as afuriPageMeta } from "./afuri.mdx";
export const meta = {
  path: "/media/harajuku/initial",
  title: "【行列店】北海道のシメパフェ「INITIAL』が原宿に！",
  description: "原宿の裏原通りにできた人気のシメパフェ専門店「INITIAL」についてご紹介します。北海道発祥のお店で、北海道の牛乳を使って作る濃厚なパフェが話題となり、連日行列ができるほどの人気店です。お店の雰囲気、人気メニュー、行列情報をお届けしますので、ぜひINITIALに行く際には参考にしてください。",
  topImg: harajukuInitialInitialImage,
  author: murakamiMasanori,
  tags: ["原宿", "行列店", "人気店", "お店の紹介", "デート", "女子会", "スイーツ", "インスタ映え"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿の裏原通りにできた人気のシメパフェ専門店「INITIAL」についてご紹介します。`}</p>
    <p>{`北海道発祥のお店で、北海道の牛乳を使って作る濃厚なパフェが話題となり、連日行列ができるほどの人気店です。その待ち時間は時には 1 時間を超えることもあるそう。`}</p>
    <p>{`原宿っぽくないお店の雰囲気、フルーツとたくさん使った人気メニュー、どの時間帯にいけば並ばずに入れるかの行列情報をお届けしますので、ぜひ INITIAL に行く際には参考にしてください。`}</p>
    <h2>{`シメパフェ「INITIAL』`}</h2>
    <InstaImage postId="B0hgREdAxlR" mdxType="InstaImage" />
    <p>{`北海道発祥のお店で、2019 年 5 月 1 日にオープンしたばかりのパフェの専門店。
北海道では定番となった「シメパフェ」の人気店が東京に上陸しました。`}</p>
    <p>{`裏原エリアに位置する INITIAL は、ピザの名店 KEVELOS やハンバーガーの名店「ザ　グレートバーガー」の隣にあるので、わかりやすい場所にあります。
土日は行列ができるほどの人気店で、パフェが売り切れてしまったりすることもあるそう。`}</p>
    <h3>{`シメパフェとは？`}</h3>
    <InstaImage postId="CAokzrcALPP" mdxType="InstaImage" />
    <p>{`お酒を飲んだや食後のシメといえばラーメンや雑炊などをイメージする方も多いのではないでしょうか。
でも北海道では 1 日の最後をパフェでシメる文化が、ここ近年若者を中心に定着しつつあり、それをシメパフェと呼ぶようになったそう。
食後に甘いデザートを食べるような感覚に近いのかもしれません。`}</p>
    <h3>{`おしゃれな店内`}</h3>
    <InstaImage postId="Bw8fK-WgaZx" mdxType="InstaImage" />
    <p>{`白とグレーを中心とした内装になっており、温かみはありつつもどこか落ち着きを感じさせるような店内。雰囲気が良いので、カップル、女子会などいろんなニーズに応えられるようなお店は、原宿というよりも表参道のような印象。`}</p>
    <hr></hr>
    <h2>{`人気メニュー`}</h2>
    <p>{`北海道の牛乳を使って作るパフェは全てが、驚くほど濃厚な味わい。そんな INITIAL のシメパフェの中で、人気のメニューをご紹介させていただきます。`}</p>
    <h3>{`苺のパフェ`}</h3>
    <InstaImage postId="Bxd1PSfA3QW" mdxType="InstaImage" />
    <p>{`INITIAL のシメパフェの中で、最も人気な看板メニューがこちらの苺のパフェ。どっさりと均等に配置された苺は、美しさがありつつボリュームを感じます。容器のしたの方にも苺やクリームがたくさん詰まっており、食べ応え抜群のシメパフェです。
原宿の INITIAL にきたら、一度は食べてみたい、そんな味になっています。`}</p>
    <InstaImage postId="ByPTxVPAJoe" mdxType="InstaImage" />
    <h3>{`ぶどうのパフェ`}</h3>
    <p>{`INITIAL で苺のパフェに次いで人気なのが、こちらのぶどうのパフェ。大きなソフトクリームの外側に、巨峰とマスカットが色違いで配列されていて、シュッッとした印象を感じます。苺のパフェと同じく、容器の下部にはマスカットやクリームがしっかり詰まっており、ボリューム感のある一品です、`}</p>
    <h3>{`テイクアウトパフェ`}</h3>
    <InstaImage postId="B_t6UVvgZTD" mdxType="InstaImage" />
    <p>{`原宿の INITIAL ではテイクアウトのメニューもあり、おいしいパフェを店外でも食べることができます。行列ができる人気店なので、外で待てない方や店内で食べなくても良いという方には、テイクアウトのメニューがおすすめです。
テイクアウトしてパフェを食べるという経験はなかなかできないと思うので、期になる方はトライしてみてください！`}</p>
    <h3>{`4 種類のソフトクリーム`}</h3>
    <InstaImage postId="B1r8N0CgcIp" mdxType="InstaImage" />
    <p>{`全てのパフェはソフトクリームをベースとしているそうで、`}<strong parentName="p">{`北海道牛乳 / チョコレート / ピスタチオ / フランボワーズ`}</strong>{`の四つのソフトクリームが選べるそう。普段はパフェだけ食べている人も、通りすがりにソフトクリームを注文して食べてみるのもおすすめかもしれません！`}</p>
    <hr></hr>
    <h2>{`行列情報`}</h2>
    <p>{`平日は行列ができることは少ないのですが、休日は大行列ができていることが多いです。12~16 時頃の間は、長い時で 1 時間以上待他ないといけないくらい、行列ができていることもしばしば。売り切れになって食べられなくなるメニューもあるのた、早い時間帯かランチタイムの時間帯を狙って行くことがおすすめになっています。`}</p>
    <p>{`早めのランチを済ませ、原宿の INITIAL でシメパフェを堪能しましょう！`}</p>
    <ShopInfoBox shopId="brqcafi23akg00ce85dg" mdxType="ShopInfoBox" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`原宿のシメパフェの人気店 INITIAL について、ご紹介してきましたがいかがでしたでしょうか。原宿で 1 番人気のパフェと言っても過言ではないお店なので、スイーツが食べたくなった際には、早めの時間帯を狙ってシメパフェを食べてみてください！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;